import { FC, useEffect, useState } from 'react';
import styles from './index.module.css';
import { RotateLoading } from '../rotate-loading';
import { rawApp } from '../../store/app/app.raw.ts';
import { AppType } from '../apps/types/app.type.ts';

export const Iframe: FC<AppType> = (iframe) => {
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        rawApp.openedApps.push(iframe);

        return () => {
            const index = rawApp.openedApps.findIndex((app) => app.id === iframe.id);
            if (index !== -1) rawApp.openedApps.splice(0, 1);
        };
    }, []);

    return (
        <div className={styles.div0}>
            {loading && (
                <div className={styles.loading}>
                    <RotateLoading />
                </div>
            )}
            <iframe
                src={`${iframe.homeUrl}?parentOrigin=${window.origin}`}
                className={styles.div0}
                style={loading ? { visibility: 'hidden', height: 0 } : {}}
                onLoad={() => setLoading(false)}
            />
        </div>
    );
};
